export default class Template {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      themeId: null,
      translations: {
        de: {
          name: null
        },
        en: {
          name: null
        }
      },
      isAccountAllowed: true,
      isFooter: false,
      isHeader: false,
      listPosition: null,
      renderIndividually: false,
      useTextVersion: false,
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  setSave(data) {
    this.set(data)
    return this.save()
  }

  save() {
    return this.store.dispatch('templates/update', this)
  }

  getJSON() {
    return {
      id: this.id,
      themeId: this.themeId,
      translations: this.translations,
      isAccountAllowed: this.isAccountAllowed,
      isFooter: this.isFooter,
      isHeader: this.isHeader,
      listPosition: this.listPosition,
      renderIndividually: this.renderIndividually,
      useTextVersion: this.useTextVersion
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/template/model.js